import React, { Component } from 'react';
import axios from 'axios';

class Candidate extends Component {
  constructor(){
    super();
    this.state = {
      rejected: 'Reject',
      accepted: 'Accept',
    };
  }

  render() {
    const {first_name, last_name, phone_number, email, zip, biz_exp, selling_exp, status } = this.props;
    let rejectState = (status == 'rejected') ? 'Rejected' : this.state.rejected
    let acceptState = (status == 'accepted') ? 'Accepted' : this.state.accepted

    return (
      <tr>
        <td> <abbr title={ first_name }>{ first_name.substring(0, 10) }</abbr> </td>
        <td> <abbr title={ last_name }>{ last_name.substring(0, 10) } </abbr></td>
        <td className="is-hidden-mobile"> { phone_number }  </td>
        <td className="is-hidden-mobile"> <abbr title={ email }>{ email.substring(0, 14) }</abbr> </td>
        <td className="is-hidden-mobile"> { zip } </td>
        <td className="is-hidden-mobile"> { biz_exp } </td>
        <td className="is-hidden-mobile"> { selling_exp } </td>
        <td> <a href="#" onClick={this._rejectCandidate.bind(this)}>{ rejectState }</a>
              |
             <a href="#" onClick={this._acceptCandidate.bind(this)}>{ acceptState }</a>
        </td>
      </tr>
      );
    }

    _rejectCandidate(e){
      e.preventDefault();
      const self = this;
      let path = `/admin/candidates/${this.props.id}/reject_candidate`
      axios.put(path).then(response => {
        self.setState({rejected: 'Rejected'})
      });
    }

    _acceptCandidate(e){
      e.preventDefault();
      const self = this;
      let path = `/admin/candidates/${this.props.id}/accept_candidate`
      axios.put(path).then(response => {
        self.setState({accepted: 'Accepted'})
      });
    }

  }

export default Candidate;
